import { api } from '../../lib/api';

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const reportsApi = {
  spend: (params = {}) => api.get(`/reports/spend${toQuery(params)}`),
  kpis: (params = {}) => api.get(`/reports/kpis${toQuery(params)}`),
  savings: (params = {}) => api.get(`/reports/savings${toQuery(params)}`),
};

// Date-range presets shown in the Reports filter. Each resolves to a {from} ISO date
// (to defaults to today on the server).
export const RANGE_PRESETS = [
  { value: '3m', label: 'Last 3 months', months: 3 },
  { value: '6m', label: 'Last 6 months', months: 6 },
  { value: '12m', label: 'Last 12 months', months: 12 },
  { value: 'ytd', label: 'Year to date', ytd: true },
];

export function resolveRange(presetValue) {
  const preset = RANGE_PRESETS.find((p) => p.value === presetValue) || RANGE_PRESETS[2];
  const now = new Date();
  let from;
  if (preset.ytd) {
    from = new Date(now.getFullYear(), 0, 1);
  } else {
    from = new Date(now.getFullYear(), now.getMonth() - (preset.months - 1), 1);
  }
  return { from: from.toISOString().slice(0, 10) };
}
